import { styled } from '../styled';

import { Box } from './box';

export const StyledAuthFormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
